
function currenyFormatter(curreny){
    return parseFloat(curreny || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })
}

export default currenyFormatter;
